import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCSpritzi extends NPC {
    constructor() {
        super(definitions.NPC_ID.SPRITZI);

        this.collisionRadius = 20;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_spritzi_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.7, new PIXI.Point(0, -8));
        this.animateIdle(0.4);
    }
}